import type {
  EnrollmentStepSubmissionResponse,
  submitEnrollmentStepRequest
} from '@/api/enrollment-api'

export const mergeSubmittedStepData = (
  response: EnrollmentStepSubmissionResponse,
  data: Parameters<typeof submitEnrollmentStepRequest>[0]['data']
): EnrollmentStepSubmissionResponse => {
  return {
    ...response,
    dateOfBirth: data.dateOfBirth ?? response.dateOfBirth,
    usCitizen: data.usCitizen ?? response.usCitizen,
    gender: data.gender ?? response.gender,
    ethnicity: data.ethnicity ?? response.ethnicity,
    educationLevel: data.educationLevel ?? response.educationLevel,
    driversLicenseState: data.driversLicenseState ?? response.driversLicenseState,
    driversLicenseNumber: data.driversLicenseNumber ?? response.driversLicenseNumber,
    driversLicenseIssueDate: data.driversLicenseIssueDate ?? response.driversLicenseIssueDate,
    driversLicenseExpiry: data.driversLicenseExpiry ?? response.driversLicenseExpiry,
    emergencyContactName: data.emergencyContactName ?? response.emergencyContactName,
    emergencyContactPhone: data.emergencyContactPhone ?? response.emergencyContactPhone,
    zipCode: data.zipCode ?? response.zipCode,
    locationExternalId: data.locationExternalId ?? response.locationExternalId,
    trainingLocationExternalId: data.locationExternalId ?? response.trainingLocationExternalId,
    programExternalId: data.programExternalId ?? response.programExternalId,
    preferredTransmission: data.preferredTransmission ?? response.preferredTransmission,
    trainingMode: data.trainingMode ?? response.trainingMode,
    hasLaptop: data.hasLaptop ?? response.hasLaptop,
    preferredStartDate: data.preferredStartDate ?? response.preferredStartDate,
    yardDays: data.yardDays ?? response.yardDays
  }
}
